// Thumbnail of a format variant: assets/catalog/<slug>-<variant>.webp (copied from
// aidea.console public/newchat/catalog), emitted as separate files by webpack (asset/resource).
// null when missing (or under jest, which has no require.context) → the card shows an icon.
const catalog =
  typeof require.context === "function"
    ? require.context("./assets/catalog", false, /\.webp$/)
    : null;

export function catalogThumb(slug, variant) {
  try {
    return catalog ? catalog(`./${slug}-${variant}.webp`) : null;
  } catch {
    return null;
  }
}
